import { defineTokens } from "@chakra-ui/react-v3";

export const easings = defineTokens.easings({
  easeIn: { value: "cubic-bezier(0.4, 0, 1, 1)" },
  easeOut: { value: "cubic-bezier(0, 0, 0.2, 1)" },
  easeInOut: {
    value: "cubic-bezier(0.4, 0, 0.2, 1)",
  },
  // Dips before it moves and overshoots before it settles; for playful motion
  // like the nav logo, not for UI transitions.
  easeInOutBack: { value: "cubic-bezier(0.68, -0.6, 0.32, 1.6)" },
});

export const durations = defineTokens.durations({
  extraFast: { value: "100ms" },
  fast: { value: "200ms" },
  normal: { value: "300ms" },
  slow: { value: "400ms" },
  extraSlow: { value: "500ms" },
  // One cycle of a looping loading animation (the Skeleton shimmer), not a
  // transition; keep it in sync with `ultraSlow` in src/theme/tokens/transition.ts.
  ultraSlow: { value: "5000ms" },
  // One cycle of the `pulse` keyframes (the public boot shell's logo), not a
  // transition; keep it in sync with `pulse` in src/theme/tokens/transition.ts.
  pulse: { value: "2000ms" },
});
